import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=1b4342f4"
import script from "./tutor.vue?vue&type=script&lang=js"
export * from "./tutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports